import { CreateInviteDialog } from '@/true-fsd/features/CreateInvite';
import { PermissionsTable } from '@/true-fsd/features/PermissionsTable';
import { Button } from '@/true-fsd/shared/ui/ButtonLink';
import PersonCircleIcon from '@synapex/frontend-shared/icons/person-circle-18.svg?react';

import { useActiveWorkspace } from '@/true-fsd/data/advertiser-account';
import { CSSProperties } from 'react';
import classes from './PermissionsPage.module.scss';

const STYLE = {
  button: {
    height: 36,
    borderRadius: 8,
    fontSize: 13,
  },
  buttonIcon: {
    width: 18,
    height: 18,
  },
} satisfies Record<string, CSSProperties>;

export type PermissionsPageProps = {};
export const PermissionsPage = ({}: PermissionsPageProps) => {
  const { activeAccount, activeWorkspace, owner } = useActiveWorkspace();

  return (
    <div className={classes.root}>
      <h1 className={classes.header}>Настройки доступа</h1>
      {activeAccount && (
        <div className={classes.buttonHolder}>
          <CreateInviteDialog
            advertiser_account_id={activeAccount.advertiser_account_id}
          >
            <Button
              style={STYLE.button}
              variant={'primary'}
              PrefixIcon={PersonCircleIcon}
              prefixIconStyle={STYLE.buttonIcon}
            >
              Добавить пользователя
            </Button>
          </CreateInviteDialog>
        </div>
      )}
      <PermissionsTable
        owner={owner}
        account={activeAccount}
        workspace={activeWorkspace}
        className={classes.table}
      />
    </div>
  );
};
